export const childPickupBehaviorIds = {
    ShowOtherParentsPickupOption: 'ShowOtherParentsPickupOption',
    RequiresPickupInfo: 'RequiresPickupInfo',
    CanCreateRelation: 'CanCreateRelation',
};
